import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-punchout-order-placed',
  templateUrl: './punchout-order-placed.component.html',
  styleUrls: ['./punchout-order-placed.component.scss'],
  standalone: false
})
export class PunchoutOrderPlacedComponent implements OnInit {
  protected route = inject(ActivatedRoute);

  orderId = '';

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams?.punchout_order_id) {
      this.orderId = queryParams.punchout_order_id;
    }
  }
}
